import { createAsyncThunk } from "@reduxjs/toolkit";
import API from "../../../Api/Api";
import { ENDPOINTS } from "../../../Api/Endpoints";

const getError = (error, fallback) =>
  error?.response?.data?.message ||
  error?.response?.data?.error ||
  error?.message ||
  fallback;

const pickByRole = (isHospitalFlow, hospitalValue, doctorValue) =>
  isHospitalFlow ? hospitalValue : doctorValue;

const extractSelections = (payload) => {
  const root = payload?.data ?? payload;
  const list =
    root?.selections ??
    root?.data?.selections ??
    root?.items ??
    root?.data?.items ??
    [];
  return Array.isArray(list) ? list : [];
};

export const getDoctorProfile = createAsyncThunk(
  "doctorExpertise/getDoctorProfile",
  async ({ isHospitalFlow = false } = {}, { rejectWithValue }) => {
    try {
      const path = pickByRole(isHospitalFlow, ENDPOINTS.HOSPITAL_ME, ENDPOINTS.DOCTOR_ME);
      const res = await API.get(path);
      return res?.data ?? res;
    } catch (error) {
      return rejectWithValue(getError(error, "Failed to fetch profile"));
    }
  }
);

export const getDoctorSelections = createAsyncThunk(
  "doctorExpertise/getDoctorSelections",
  async ({ isHospitalFlow = false } = {}, { rejectWithValue }) => {
    try {
      const path = pickByRole(
        isHospitalFlow,
        ENDPOINTS.GET_HOSPITAL_SELECTIONS,
        ENDPOINTS.GET_DOCTOR_SELECTIONS
      );
      const res = await API.get(path);
      return extractSelections(res?.data ?? res);
    } catch (error) {
      return rejectWithValue(getError(error, "Failed to fetch selections"));
    }
  }
);

export const getDoctorCategories = createAsyncThunk(
  "doctorExpertise/getCategories",
  async ({ isHospitalFlow = false } = {}, { rejectWithValue }) => {
    try {
      const path = pickByRole(
        isHospitalFlow,
        ENDPOINTS.GET_HOSPITAL_CATEGORIES,
        ENDPOINTS.GET_DOCTOR_CATEGORIES
      );
      const res = await API.get(path);
      return res?.data ?? res;
    } catch (error) {
      return rejectWithValue(getError(error, "Failed to fetch categories"));
    }
  }
);

export const getDoctorSubcategories = createAsyncThunk(
  "doctorExpertise/getSubcategories",
  async ({ categoryId, isHospitalFlow = false } = {}, { rejectWithValue }) => {
    try {
      const path = pickByRole(
        isHospitalFlow,
        ENDPOINTS.GET_HOSPITAL_SUBCATEGORIES,
        ENDPOINTS.GET_DOCTOR_SUBCATEGORIES
      );
      const res = await API.get(path, {
        params: { categoryId },
      });

      return {
        categoryId,
        data: res.data,
      };
    } catch (error) {
      return rejectWithValue({
        categoryId,
        message: getError(error, "Failed to fetch subcategories"),
      });
    }
  }
);

export const createDoctorSelections = createAsyncThunk(
  "doctorExpertise/createSelections",
  async ({ payload, isHospitalFlow = false } = {}, { rejectWithValue }) => {
    try {
      const path = pickByRole(
        isHospitalFlow,
        ENDPOINTS.CREATE_HOSPITAL_SELECTION,
        ENDPOINTS.CREATE_DOCTOR_SELECTION
      );
      const res = await API.post(path, payload);
      return res?.data ?? res;
    } catch (error) {
      return rejectWithValue(getError(error, "Failed to create selection"));
    }
  }
);
